module.exports = __webpack_public_path__ + "img/w3_technical_dark.c49b1625.png";